import { useMutation } from 'query';
import { changeRequest } from 'features/change-requests';
import type { ContactUsFormValues } from '../../contact-us';

/**
 * @deprecated Move this query into the change-requests feature. It belongs next to `changeRequest`, not under programs.
 */
export const useProgramChangeRequestMutation = () =>
  useMutation<undefined, { data: ContactUsFormValues; programId: string }>({
    async mutationFn({ data, programId }) {
      await changeRequest({
        body: {
          kind: 'program_request_to_contact',
          meta: {
            invitation_phone: data.invitationPhone,
          },
          subject_id: programId,
          subject_type: 'Program',
        },
      });

      return undefined;
    },
  });
